import React from 'react';
import { Tab, Tabs } from '@mui/material';
import JsonTreeViewer from './JsonTreeViewer';

const MockupsDataTabs = ({ value, onChange, mockupsToolbar, mockupsContent, rawData, extraTabs = [] }) => {
  const activeExtraTab = extraTabs.find((tab) => tab.value === value) || null;

  return (
    <>
      <Tabs
        value={value}
        onChange={(event, next) => onChange?.(next)}
        variant="scrollable"
        scrollButtons="auto"
        allowScrollButtonsMobile
        sx={{ mb: 2 }}
      >
        <Tab value="mockups" label="Mockups" />
        {extraTabs.map((tab) => (
          <Tab key={tab.value} value={tab.value} label={tab.label} />
        ))}
        <Tab value="data" label="Data" />
      </Tabs>
      {value === 'mockups' ? (
        <>
          {mockupsToolbar}
          {mockupsContent}
        </>
      ) : activeExtraTab ? (
        activeExtraTab.content
      ) : (
        <JsonTreeViewer data={rawData} />
      )}
    </>
  );
};

export default MockupsDataTabs;
